module.exports = __webpack_public_path__ + "static/media/location.d1a79014.svg";